import { useEffect, useRef, useState } from "react";
import WhatsappService, {
  WhatsappTemplateItemType,
  WhatsappTemplateListType
} from "../../services/WhatsappService";
import { TemplatePopoverProps } from "./typings";
import { ToastService } from "../../pages/shared/bootstrap/Toast";
import { TranslationService } from "../../services/TranslationService";

export const TemplatePopover = ({
  open,
  onClose,
  anchorRef,
  onPick,
  openchat
}: TemplatePopoverProps) => {
  const [data, setData] = useState<WhatsappTemplateListType>();
  const containerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const load = async () => {
      const result = await WhatsappService.getList();
      if (result instanceof Error) {
        ToastService.showToast(
          "Error al obtener templates",
          undefined,
          "danger"
        );
        return;
      }
      setData(result);
    };
    if (open) load();
  }, [open]);

  useEffect(() => {
    const onDocClick = (e: MouseEvent) => {
      if (!open) return;
      const target = e.target as Node;
      if (
        containerRef.current &&
        !containerRef.current.contains(target) &&
        anchorRef.current &&
        !anchorRef.current.contains(target)
      ) {
        onClose();
      }
    };
    document.addEventListener("mousedown", onDocClick);
    return () => document.removeEventListener("mousedown", onDocClick);
  }, [open, onClose, anchorRef]);

  if (!open) return null;

  const items = (data?.list ?? [])
    .filter((x) => x.Parameters === 0 || (x.Parameters > 0 && x?.FieldList))
    .map((t) => ({
      id: t.WATemplateID,
      name: t.Name ?? "",
      structure: t.Structure ?? "",
      parameters: t.Parameters ?? 0,
      fieldList: t.FieldList ?? ""
    }));

  return (
    <div className="wa-popover" ref={containerRef}>
      <div className="wa-popover-header">
        {TranslationService.translate.WhatsAppTemplate}
      </div>

      {openchat && (
        <div
          className="wa-popover-item"
          onClick={() => {
            onPick("0");
            onClose();
          }}
        >
          <div>{TranslationService.translate.WriteMessage}</div>
          <small>{TranslationService.translate.TypeYourMessage}</small>
        </div>
      )}

      {items.map((it) => (
        <div
          key={it.id}
          className="wa-popover-item"
          onClick={() => {
            onPick({
              WATemplateID: it.id,
              Name: it.name,
              Structure: it.structure,
              Parameters: it.parameters,
              FieldList: it.fieldList
            } as WhatsappTemplateItemType);
            onClose();
          }}
        >
          <div>{it.name}</div>
          <small title={it.structure}>{it.structure}</small>
        </div>
      ))}
    </div>
  );
};
